import ItemDetails, { Field } from "./itemDetails";
export default ItemDetails;
export { Field };
